import { PageContainer } from 'components';

import { MainContainer } from '@britishcouncil/react-solas-ors3';
import { BcAlert } from '@britishcouncil/react-solas';

import { ExamsGroups } from './components/ExamsGroups';
import { useMyRegistrationsData } from './useMyRegistrationsData';

const RussiaCountryId = 78;

export const MyRegistrations = () => {
  const { user, isLoading, data: summary } = useMyRegistrationsData();

  const shouldShowRussiaWarning = (summary: any): boolean => {
    if (!summary) return false;

    const now = new Date();

    const allExams = summary?.exams ?? [];

    var candidate = summary.candidate;
    var minors = summary.childCandidates ?? [];

    var allCandidates = [candidate, ...minors];

    const hasUpcomingRussiaExam = allExams.some((exam: any) => {
      const isFuture = exam.sessionExamStart && new Date(exam.sessionExamStart) >= now;
      const notCancelled = !exam.isCanceled;

      const candidate = allCandidates.find((c: any) => c.id === exam.candidateId);
      const isCandidateFromRussia = candidate && Number(candidate.address.countryId) === RussiaCountryId;

      return isFuture && notCancelled && isCandidateFromRussia;
    });


    return hasUpcomingRussiaExam;
  };

  return (
    <>
      <MainContainer>
        <h1>Registrations</h1>

        {shouldShowRussiaWarning(summary) &&
          <BcAlert type="note" title="Important Notice">
            <p>
              Please be informed that the British Council has been included in the register of "undesirable
              organisations" in Russia. This is related to a change in Russian legislation that impacts organisations
              linked to foreign governments that are viewed as undesirable by the Russian government. Any
              connection with the British Council could potentially entail risks for individuals who are Russian
              citizens or have other ties to Russia. This applies even if the individuals live outside of Russia. We
              encourage you to consider this situation carefully and assess personal risks.
            </p>
            <p>
              If you no longer wish to proceed with your test as a result of this change, you may request a full
              refund by contacting us.
            </p>
          </BcAlert>
        }
      </MainContainer>

      <PageContainer loading={isLoading}>
        {summary && (
          <>
            <h2>
              {user?.firstName} {user?.lastName} you have {summary?.exams.length} registrations
            </h2>

            <ExamsGroups exams={summary?.exams ?? []} />
          </>
        )}
      </PageContainer>
    </>
  );
};
